























































































































































































































import {
	Vue,
	Component,
	Ref,
	Watch,
} from 'vue-property-decorator'
import {
	FechamentoDeCaixa,
	ItemDeFechamento,
	FormDeFechamentoDeCaixa,
	Page,
	Loja,
	Pageable,
	SituacaoAudicao,
} from '@/models'
import {
	FindFechamentoDeCaixaUseCase,
	SaveFechamentoDeCaixaUseCase,
	FindTurnoDeVendaUseCase,
	LojaServiceAdapter,
} from '@/usecases'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import DataTableDeCrudPaginado from '@/components/ui/DataTableDeCrudPaginado.vue'
import DialogoDeAuditoria from './DialogoDeAuditoria.vue'
import SeletorDeLojas from '@/components/loja/SeletorDeLojas.vue'
import DialogoDeDetalhesDeFechamento from '@/components/venda/DialogoDeDetalhesDeFechamento/DialogoDeDetalhesDeFechamento.vue'
import SnackbarDeAuditoria from './SnackbarDeAuditoria.vue'
import RangeDatePicker from '@/components/ui/RangeDatePicker.vue'
import moment from 'moment'
import Axios, { CancelToken, CancelTokenSource } from 'axios'
import { formatarDataHora, formatarMoeda } from '@/shareds/formatadores'
import ImportadorDeArquivos from './ImportadorDeArquivos.vue'
import { Inject } from 'inversify-props'
import { uploadFilesToS3 } from '@/shareds/s3/files'
import DialogoDeAnexarArquivosNoFechamento from '@/components/venda/DialogoDeDetalhesDeFechamento/DialogoDeAnexarArquivosNoFechamento.vue'
import request from '@/common/request'
import print from 'print-js'

import SeletorDeUsuario from '@/components/usuario/SeletorDeUsuario.vue'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import JSZip from 'jszip'

const ULTIMO_FILTRO_DE_FECHAMENTO = 'ULTIMO_FILTRO_DE_FECHAMENTO'

export type FiltroDeFechamento = {
	lojaId: Loja | null
	pdvId: string | null
	datas: (string | null)[]
	situacoes: SituacaoAudicao[]
	usuarioFechamento?: string | null
}

function obterFiltrosDeFechamentosIniciais(): FiltroDeFechamento {
	return {
		lojaId: null,
		pdvId: null,
		datas: [],
		situacoes: ['Pendente'],
		usuarioFechamento: null,
	}
}

@Component({
	components: {
		SeletorDeLojas,
		RangeDatePicker,
		DialogoDeAuditoria,
		SnackbarDeAuditoria,
		ImportadorDeArquivos,
		DataTableDeCrudPaginado,
		DialogoDeDetalhesDeFechamento,
		SeletorDeUsuario,
		DialogoDeAnexarArquivosNoFechamento,
	},
})
export default class TelaDeFechamentos extends Vue {
	@Ref() dialogoDeAuditoria!: DialogoDeAuditoria
	@Ref() snackbarDeAuditoria!: SnackbarDeAuditoria
	@Ref() dataTablePaginado!: DataTableDeCrudPaginado
	@Ref() dialogoDeImportadorDeArquivos!: ImportadorDeArquivos
	@Ref() dialogoDeAnexarArquivosNoFechamento!: DialogoDeAnexarArquivosNoFechamento
	@Ref() fileInput!: HTMLInputElement

	get headers() {
		const base = [
			{ text: 'Data e Hora', value: 'dataHoraFechamento' },
			{ text: 'PDV', value: 'turnoDeVenda.pontoDeVenda.nome' },
			{ text: 'Diferença (R$)', value: 'diferenca', class: ['text-right text-no-wrap'], width: '120px', sortable: false },
		]

		if (this.permiteAuditarEConfirmarFechamento) {
			base.push({ text: 'Situação', value: 'situacaoAudicao' })
		}

		return base
	}

	filtros = localStorage[ULTIMO_FILTRO_DE_FECHAMENTO]
		? JSON.parse(localStorage[ULTIMO_FILTRO_DE_FECHAMENTO])
		: obterFiltrosDeFechamentosIniciais()
	carregando = false
	formatarMoeda = formatarMoeda
	formatarDataHora = formatarDataHora
	fechamentos: FechamentoDeCaixa[] = []
	fechamentoSelecionado: FechamentoDeCaixa | null = null
	findTurnoDeVendaUseCase = new FindTurnoDeVendaUseCase()
	findFechamentoDeCaixaUseCase = new FindFechamentoDeCaixaUseCase()
	saveFechamentoDeCaixaUseCase = new SaveFechamentoDeCaixaUseCase()
	loja: Loja | null = null
	fechamentoParaAnexo: FormDeFechamentoDeCaixa | null = null
	uploadandoArquivos = false
	baixandoArquivo: string[] = []
	baixandoTodosOsAnexos = false

	@Inject('LojaServiceAdapter')
	private lojaService!: LojaServiceAdapter
	
	buscandoLoja = false
	cancelToken: CancelTokenSource | null = null

	get lojaId() {
		return this.filtros.lojaId
	}

	limparFiltros() {
		this.filtros = obterFiltrosDeFechamentosIniciais()
		this.aplicarFiltros()
	}

	@Watch('lojaId', { immediate: true })
	async onChangeLoja(lojaId: string | null, lojaIdAnterior: string | null) {
		if (!lojaId || (lojaIdAnterior !== undefined && lojaId !== lojaIdAnterior)) {
			this.filtros.pdvId = null
		}
		if (lojaId) {
			try {
				this.buscandoLoja = true
				if (this.cancelToken) this.cancelToken.cancel()
				this.cancelToken = Axios.CancelToken.source()
				this.loja = await this.lojaService.get(lojaId, {
					cancelToken: this.cancelToken.token,
				})
			} catch (e) {
				if (Axios.isCancel(e)) return
				AlertModule.setError(e)
			} finally {
				this.buscandoLoja = false
			}
		}
	}

	async buscarPagina(paginavel: Pageable, parametros: {
		dataInicialDeFechamento?: string
		dataFinalDeFechamento?: string
		lojaId?: string
	}, cancelToken: CancelToken): Promise<Page<FechamentoDeCaixa>> {
		const pagina = await this.findFechamentoDeCaixaUseCase.find({
			...parametros,
			...paginavel,
		}, {
			cancelToken,
		})
		this.fechamentos = pagina.content
		return pagina
	}

	aplicarFiltros() {
		localStorage[ULTIMO_FILTRO_DE_FECHAMENTO] = JSON.stringify(this.filtros)
		this.dataTablePaginado.reiniciar(this.filtrosFormatados)
	}

	get filtrosFormatados() {
		return {
			dataInicialDeFechamento: this.filtros.datas[0] && this.filtros.datas[1]
				? moment(this.filtros.datas[0]).toISOString(true)
				: undefined,
			dataFinalDeFechamento: this.filtros.datas[0] && this.filtros.datas[1]
				? moment(`${this.filtros.datas[1]} 23:59:59`).toISOString(true)
				: undefined,
			lojaId: this.filtros.lojaId || undefined,
			pdvId: this.filtros.pdvId || undefined,
			situacoes: this.filtros.situacoes,
			usuarioFechamento: this.filtros.usuarioFechamento || undefined,
		}
	}

	abrirDialogoDeAuditoriaDoFechamento(fechamentoDeCaixa: FormDeFechamentoDeCaixa) {
		this.dialogoDeAuditoria.mostrar(fechamentoDeCaixa)
	}

	async atualizarSituacaoAuditoriaDoFechamento(fechamentoDeCaixa: FormDeFechamentoDeCaixa) {
		try {
			this.carregando = true
			fechamentoDeCaixa.situacaoAudicao = 'Concluído'
			const fechamentoAtualizado = await this.saveFechamentoDeCaixaUseCase.update(fechamentoDeCaixa)
			this.atualizarFechamentoDeCaixa(fechamentoAtualizado)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregando = false
		}
	}

	atualizarFechamentoDeCaixa(fechamentoDeCaixa: FechamentoDeCaixa) {
		if (!fechamentoDeCaixa) return
		const indice = this.fechamentos.findIndex(
			fechamentoExistente => fechamentoExistente.id === fechamentoDeCaixa.id,
		)
		if (indice === -1) return
		if (!this.filtros.situacoes.includes(fechamentoDeCaixa.situacaoAudicao)) {
			this.fechamentos.splice(indice, 1);
			return
		}
		this.fechamentos.splice(indice, 1, fechamentoDeCaixa);
	}

	get registrosFormatados() {
		return this.fechamentos.map(fechamentoDoCaixa => ({
			...fechamentoDoCaixa,
			diferenca: this.calcularDiferencaValoresDoCaixa(fechamentoDoCaixa.itensDeFechamento || []),
		}))
	}

	calcularDiferencaValoresDoCaixa(itens: ItemDeFechamento[]) {
		const sumValorEsperado = itens.reduce((a, b) => a + (b.valorEsperado || 0), 0)
		const sumValorContado = itens.reduce((a, b) => a + (b.valorContado || 0), 0)
		return sumValorContado - sumValorEsperado
	}

	get pdvsOrdenados() {
		return this.loja
			? [...this.loja.pdvs ].sort((pdvA, pdvB) => pdvA.nome.localeCompare(pdvB.nome))
			: []
	}

	anexarArquivos(fechamento: FormDeFechamentoDeCaixa) {
		this.dialogoDeAnexarArquivosNoFechamento.mostrar(fechamento)
		this.fechamentoParaAnexo = fechamento
		this.fileInput.click()
	}

	async onFilesSelected(file: File) {
		if (!this.fechamentoParaAnexo) return

		try {
			this.uploadandoArquivos = true

			const nomeUnico = this.gerarNomeUnico(file.name)
			const arquivoRenomeado = new File([file], nomeUnico, { type: file.type })

			const arquivos = [arquivoRenomeado]

			const caminhoPasta = `fechamentos-de-caixa/${this.fechamentoParaAnexo.id}`
			const informacoesDosArquivos = await uploadFilesToS3(arquivos, caminhoPasta)

			const arquivosComExtensao: string[] = informacoesDosArquivos.map(
				({ config }) => config.data.name,
			)

			const fechamentoAtualizado = {
				...this.fechamentoParaAnexo,
				anexos: [
					...(this.fechamentoParaAnexo.anexos || []),
					...arquivosComExtensao,
				],
			}

			const fechamentoSalvo = await this.saveFechamentoDeCaixaUseCase.update(fechamentoAtualizado)
			this.atualizarFechamentoDeCaixa(fechamentoSalvo)

			AlertModule.setSuccess(`${arquivos.length} arquivo(s) anexado(s) com sucesso!`)
		} catch (error) {
			AlertModule.setError('Erro ao anexar arquivos: ' + error)
		} finally {
			this.uploadandoArquivos = false
			this.fechamentoParaAnexo = null
		}
	}

	get permiteVisualizarDetalhesDoFechamento(){
		return UserLoginStore.permiteRegraDeNegocio('permite-visualizar-detalhes-do-fechamento')
	}

	get permiteAuditarEConfirmarFechamento(){
		return UserLoginStore.permiteRegraDeNegocio('permite-auditar-e-confirmar-fechamento')
	}

	async getFileFromS3(caminhoDaPasta: string, nomeDoArquivo: string): Promise<Blob> {
		const extensaoDoArquivo = nomeDoArquivo.substring(nomeDoArquivo.lastIndexOf('.') + 1)

		const presignedUrl = await request.post<{ fileName: string; contentType: string }, string>(
			'/pre-signed-url',
			{
				fileName: nomeDoArquivo,
				folderName: caminhoDaPasta,
				contentType: extensaoDoArquivo,
				httpMethod: 'GET',
			},
		)

		const response = await fetch(presignedUrl)
		if (!response.ok) {
			throw new Error(`Erro ao buscar arquivo ${nomeDoArquivo}`)
		}

		return await response.blob()
	}
	
	async baixarTodosOsAnexos() {
		this.baixandoTodosOsAnexos = true

		try {
			const zip = new JSZip()

			for (const fechamento of this.fechamentos) {
				const caminhoDaPasta = `fechamentos-de-caixa/${fechamento.id}`

				for (const anexo of fechamento.anexos) {
					try {
						const nomeDoArquivoLimpo = anexo.includes('_')
							? anexo.substring(0, anexo.lastIndexOf('_'))
							: anexo
						const filePath = `${nomeDoArquivoLimpo}`

						// eslint-disable-next-line no-await-in-loop
						const fileBlob = await this.getFileFromS3(caminhoDaPasta, anexo)
						zip.file(filePath, fileBlob)
					} catch (error) {
						AlertModule.setError('Erro ao baixar: ' + anexo)
					}
				}
			}

			const zipBlob = await zip.generateAsync({ type: 'blob' })
			const url = window.URL.createObjectURL(zipBlob)
			const a = document.createElement('a')
			a.href = url
			a.download = 'anexos.zip'

			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			window.URL.revokeObjectURL(url)

		} finally {
			this.baixandoTodosOsAnexos = false
		}
	}

	get podeBaixarTodosOsAnexos() {
		return UserLoginStore.permiteRegraDeNegocio('pode-baixar-todos-os-anexos')
	}

	gerarNomeUnico(nomeOriginal: string) {
		const ultimoPonto = nomeOriginal.lastIndexOf('.')
		if (ultimoPonto === -1) {
			return `${nomeOriginal}_${Date.now()}`
		}

		const nome = nomeOriginal.substring(0, ultimoPonto)
		const extensao = nomeOriginal.substring(ultimoPonto)
		return `${nome}_${Date.now()}${extensao}`
	}
}
